<div class="form-element cbta-datetime-picker">
	@if (label) {
		<mat-label>{{ label }}</mat-label>
	}
	<mat-form-field appearance="outline" class="form-field form-field-responsive mt-1 w-full">
		<input
			#datePicker
			matInput
			[placeholder]="placeHolder"
			type="text"
			[owlDateTimeTrigger]="picker"
			[owlDateTime]="picker"
			[min]="normalizedMin"
			readonly
			[formControl]="datePickerInput"
		/>
		<owl-date-time
			#picker
			pickerType="both"
			[stepMinute]="stepMinute"
			[startAt]="startAt"
			(dateSelected)="handleClose($event)"
			(afterPickerClosed)="handleClose(datePickerInput.value)"
		></owl-date-time>
		@if (showClear && datePickerInput.value) {
			<button
				type="button"
				class="cbta-datetime-picker__clear mr-1"
				matSuffix
				aria-label="Clear date and time"
				(click)="clearValue()"
			>
				<span class="aa-mat-icon text-grey-60">close</span>
			</button>
		}
		<span class="aa-mat-icon mr-4 cursor-pointer text-grey-60" [owlDateTimeTrigger]="picker" matSuffix>
			event
		</span>
		@if (errorMessage) {
			<mat-error>{{ errorMessage }}</mat-error>
		}
	</mat-form-field>
</div>
